
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { ArchiveRequest, TestEquipmentDevice } from '../../backend/backendapi';
import { equipmentNumber } from '../util';
import { RiskOption } from './archivemodal.model';
import State from '../State';

@Component({
  components: {
    vSelect,
  },
})
export default class ArchiveModal extends Vue {
  @Inject({ from: 'state' })
  readonly state!: State;

  //runtime
  equipment: TestEquipmentDevice | null = null;
  reason: string = '';
  riskOption: RiskOption | null = null;

  public open(equipment: TestEquipmentDevice): void {
    this.equipment = equipment;
    this.reason = '';
    this.riskOption = this.riskOptions[0];
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  archive(): void {
    if (!this.equipment || !this.riskOption) {
      return;
    }
    this.$emit('archive', new ArchiveRequest({ id: this.equipment.id, reason: this.reason, risk: this.riskOption.id }));
  }

  //getter
  get equipmentNumber(): string {
    if (!this.equipment) {
      return '';
    }
    return equipmentNumber(this.equipment, this.state.kindsStore.kindTypes, this.state.groupsStore.groupTypes, this.state.placeOfUsesStore.placeOfUseTypes);
  }

  get riskOptions(): RiskOption[] {
    let localRiskOptions = this.state.riskOptionsSetting[this.$i18n.locale] as RiskOption[];
    localRiskOptions ??= this.state.riskOptionsSetting['en'] as RiskOption[];
    return localRiskOptions ?? [{ id: 'none', name: 'none' }];
  }
}
